import { React, classNames, withStyles, StyledProps, CentricTheme } from '@api'
import { TextInput } from './'

const styles = (theme: CentricTheme) => ({
  root: {}
})

interface MyProps extends StyledProps {
  /** String for the name of the field */
  name: string,
  /** String for the field's label */
  label?: string,
  /** Value of the field */
  value?: any,
  /** Change handler */
  onChange?: (e?: any) => void
  /** Boolean indicating whether the field is errored or not */
  error?: boolean
  /** String for field's error text when errored */
  errorText?: string,
  /** Boolean indicating whether the button should render as disabled */
  disabled?: boolean

  rowsMax?: number
}

export class MultilineTextInputComponent extends React.Component<MyProps> {
  static defaultProps = {
    name:      '',
    label:     '',
    value:     '',
    onChange:  () => {},
    error:     false,
    errorText: '',
    disabled:  false,
    rowsMax:   5
  }

  render() {
    const {name, label, value, onChange, error, errorText, disabled, classes, rowsMax} = this.props
    return (
      <TextInput
        error={error && !disabled}
        errorText={errorText}
        label={label}
        value={value}
        onChange={onChange}
        name={name}
        className={classes.textField}
        rowsMax={rowsMax}
        multiline
        disabled={disabled}
      />
    )
  }
}

@(withStyles as any)(styles)
export class MultilineTextInput extends MultilineTextInputComponent {}



// WEBPACK FOOTER //
// ./src/shared/components/ui/components/MultilineTextInput.tsx